import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectAnswer = (state: RootState) => state.answer;

export const selectAnswers = (state: RootState) => state.answer.data;

export const selectAnswerToEdit = (state: RootState) => state.answer.toEdit;

export const selectAnswerFailed = (state: RootState) => state.answer.failed;

export const selectFilteredAnswers = (state: RootState) => state.answer.filteredAnswers;

export const selectInspectionsList = (state: RootState) => state.answer.inspections;

export const selectLoadingInspections = (state: RootState) => state.answer.loadingInspections;

export const selectErrorInspections = (state: RootState) => state.answer.errorInspections;

export const selectSelectedInspection = (state: RootState) => state.answer.selectedInspection;

export const selectAnswersGroupedByQuestionId = createSelector(
    selectAnswers,
    (answers) => {
        const grouped = answers.reduce((acc, answer) => {
            const questionId = answer.questionId;
            if (!acc[questionId]) {
                acc[questionId] = [];
            }
            acc[questionId].push(answer);
            return acc;
        }, {} as Record<string, typeof answers>);

        return Object.entries(grouped)
            .map(([questionId, answers]) => ({
                questionId,
                answers: answers.sort((a, b) => a.answerId.localeCompare(b.answerId))
            }))
            .sort((a, b) => a.questionId.localeCompare(b.questionId));
    }
);
